// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3tLsE","col":"CardReaderDesc_col__33LRs","label":"CardReaderDesc_label__2rXJ9"};